import {PortalStates} from "../../States";

const INITIAL_STATE = localStorage.getItem("portalReducer")
  ? JSON.parse(localStorage.getItem("portalReducer"))
  : "";

export const PortalReducer = (state = INITIAL_STATE, action) => {
  const {type, payload} = action;

  switch (type) {
    case PortalStates.DELETE:
      return null;
    case PortalStates.SUCCESS:
      return {...payload, reducer_status: PortalStates.SUCCESS};

    case PortalStates.FAILED:
      return {...payload, reducer_status: PortalStates.FAILED};

    case PortalStates.RESET:
      return {...INITIAL_STATE};

    default:
      return state;
  }
};
